<div class="planning">
  @if (head.length) {
    <div class="head-line">
      @for (h of head; track $index) {
        <span [class.first]="$first">{{ h.text }}@for (p of h.parties; track p.id) {@if (!$first) {, }<button type="button" class="party-link" (click)="openPartner(p.id)" title="Fiche du tiers">{{ p.name }}</button>}{{ h.post }}</span>
      }
    </div>
  }

  @if (summary.length) {
    <div class="summary">
      @for (s of summary; track $index) {
        <span [class]="s.cls ?? ''" [attr.title]="s.title || null">{{ s.pre }}@if (s.b) {<b>{{ s.b }}</b>}{{ s.post ?? '' }}</span>
      }
    </div>
  }

  <div class="toolbar">
    <div class="seg nav" role="group" aria-label="Fenêtre affichée">
      <button type="button" aria-label="Mois précédent" (click)="shift(-1)" [disabled]="!vm">◀</button>
      <button type="button" (click)="today()" [disabled]="!vm">Aujourd'hui</button>
      <button type="button" aria-label="Mois suivant" (click)="shift(1)" [disabled]="!vm">▶</button>
    </div>
    <div class="seg" role="group" aria-label="Largeur de la fenêtre">
      @for (p of presets; track p.kind) {
        <button type="button" [attr.aria-pressed]="preset === p.kind" (click)="setPreset(p.kind)" [disabled]="!vm">{{ p.label }}</button>
      }
    </div>
    @if (ownFilters && vm) {
      <div class="seg" role="group" aria-label="Matériels affichés">
        <button type="button" [attr.aria-pressed]="bucket === 'current'" (click)="setBucket('current')">En cours ({{ counts.current }})</button>
        <button type="button" [attr.aria-pressed]="bucket === 'returned'" (click)="setBucket('returned')">Repris ({{ counts.returned }})</button>
        <button type="button" [attr.aria-pressed]="bucket === 'all'" (click)="setBucket('all')">Tout ({{ counts.all }})</button>
      </div>
      <label class="chk"><input type="checkbox" [checked]="hideClosed" (change)="toggleClosed($any($event.target).checked)" />Masquer les clos</label>
    }
    @if (showSearch) {
      <input class="search" type="search" placeholder="Rechercher un résident" aria-label="Rechercher un résident" [value]="search" (input)="onSearch($any($event.target).value)" />
    }
    <span class="hint">Survol : détail · glisser sur une rangée : nouvelle interruption · clic sur un ruban : modifier</span>
    <span class="spacer"></span>
    @if (store.refreshing) {
      <mat-spinner class="spin" diameter="16" aria-label="Rechargement en cours"></mat-spinner>
    }
    @if (store.error && store.view) {
      <span class="err inline">{{ store.error }}</span>
      <button mat-stroked-button type="button" class="retry" (click)="store.reload()">Réessayer</button>
    }
    @if (docsError) {
      <span class="err inline docs-err">{{ docsError }}</span>
      <button mat-stroked-button type="button" class="retry-docs" (click)="loadDocs(true)">Réessayer</button>
    }
    @if (rxLines.length) {
      <button mat-stroked-button type="button" class="add-rx" (click)="addPrescription()">Prescription</button>
    }
    <button mat-flat-button color="primary" type="button" class="add-int" (click)="addInterruption()" [disabled]="!vm">+ Interruption</button>
  </div>

  @if (!store.view) {
    <div class="state">
      @if (store.firstLoad) {
        <mat-spinner class="first-spin" diameter="36" aria-label="Chargement du planning"></mat-spinner>
      } @else if (store.error) {
        <span class="err">{{ store.error }}</span>
        <button mat-stroked-button type="button" class="retry" (click)="store.reload()">Réessayer</button>
      } @else {
        <span class="muted">Aucun planning pour ce dossier.</span>
      }
    </div>
  } @else if (vm) {
    <div class="fr-scroll">
      <div class="frise" [style.--n]="vm.n" [style.--bg-img]="vm.bgImage" [style.--bg-size]="vm.bgSize">
        <div class="fr-headers">
          <div class="fr-row fr-head">
            <div class="fr-lab"></div>
            <div class="fr-days">
              @for (m of vm.months; track m.first) {
                <div class="fr-month" [style.left.%]="m.left" [style.width.%]="m.width" [attr.title]="m.title">{{ m.label }}</div>
              }
            </div>
          </div>
          <div class="fr-row fr-head2">
            <div class="fr-lab"></div>
            <div class="fr-days">
              @for (d of vm.days; track d.day) {
                <span class="fr-dn" [class.td]="d.today" [style.left.%]="d.left">{{ d.label }}</span>
              }
            </div>
          </div>
        </div>

        @for (g of vm.groups; track g.key) {
          <div class="fr-row pat" [attr.data-group]="g.key">
            <div class="fr-lab">
              <div class="pat-txt" (mouseenter)="onPatientEnter(g, $event)" (mouseleave)="onPatientLeave()">
                <div class="nm">{{ g.title }}</div>
                <div class="mt">{{ g.count }}</div>
              </div>
              <!-- Plus de ⋮ (JP 29/10) : il ne portait que « Fin de facturation… », devenue la croix rouge. -->
              <div class="pat-btns">
                @if (mode === 'page') {
                  <button type="button" class="ico" [attr.aria-label]="'Livrer un matériel pour ' + g.title" title="Livrer un matériel à ce patient" (click)="deliver.emit(g.memo ?? '')" [disabled]="!canDeliver">+</button>
                }
                <button type="button" class="ico clip" [attr.aria-label]="'Joindre un document pour ' + g.title" (click)="attachTo(groupLineIds(g), $event)" [disabled]="uploading"
                  (mouseenter)="onClipEnter(g, $event)" (mouseleave)="onClipLeave()">
                  <mat-icon>attach_file</mat-icon>@if (groupDocs.get(g.key); as n) {<span class="n">{{ n }}</span>}
                </button>
                <button type="button" class="ico sym" [attr.aria-label]="'Nouvelle interruption pour ' + g.title" title="Nouvelle interruption" (click)="groupAdd(g)" [disabled]="!g.readableIds.length"><mat-icon>pause_circle</mat-icon></button>
                @if (mode === 'page' && truckOf(g); as t) {
                  <button type="button" class="ico sym truck" [class.reprise]="t.reprise" [attr.aria-label]="t.title + ' : ' + g.title" [title]="t.title" (click)="planDelivery.emit(groupLineIds(g))" [disabled]="!canDeliver"><mat-icon>local_shipping</mat-icon></button>
                }
                <button type="button" class="ico sym end" [attr.aria-label]="'Fin de facturation pour ' + g.title" title="Fin de facturation de tous les matériels de ce patient" (click)="groupEnd(g)" [disabled]="!g.readableIds.length"><mat-icon>close</mat-icon></button>
              </div>
            </div>
            <div class="fr-track grp bg" [attr.data-group]="g.key" [style.height.px]="g.height">
              @for (r of g.ribbons; track r.key) {
                <button type="button" class="ribbon" [class.offer]="r.offer" [class.line]="r.partial" [class.sched]="r.scheduled" [class.open]="r.open"
                  [class.cancelled]="r.cancelled" [class.edited]="r.edited" [class.anchor-right]="r.anchorRight"
                  [style.left.%]="r.left" [style.width.%]="r.width" [style.top.px]="r.top" [style.border-color]="r.color" [attr.data-group]="g.key" [attr.data-key]="r.key"
                  [attr.aria-label]="r.aria" (click)="onRibbon(r)">
                  <span class="rdot" [style.background]="r.color"></span><span class="rlab">{{ r.label }}@if (r.missing) {<span class="miss" aria-hidden="true" (click)="onMissing(r, $event)">⚠</span>}</span>
                </button>
                @if (r.missing) {
                  <!-- Pendant clavier du ⚠ : un bouton frère, jamais dans le ruban ; visible au seul focus, à la place du ruban. -->
                  <button type="button" class="key-only miss-key" [style.left.%]="r.left" [style.top.px]="r.top" [attr.aria-label]="r.missingAria" (click)="onMissing(r, $event)">⚠ Appliquer à ce matériel</button>
                }
              }
            </div>
          </div>
          @for (r of g.lines; track r.id) {
            <div class="fr-row mat" [class.odd]="$odd" [class.row-blocked]="r.blocked" [attr.data-line]="r.id">
              <!-- Survol : fenêtre des pièces jointes du matériel, qui porte aussi le lien du contrat (plus d'info-bulle sur le nom). -->
              <button type="button" class="fr-lab" (click)="onLineLabel(r)" [attr.aria-label]="'Fiche de ' + r.name">
                <span class="l1">
                  @if (r.contract) {
                    <span class="nm link" (click)="onContract(r, $event)">{{ r.name }}</span>
                  } @else {
                    <span class="nm">{{ r.name }}</span>
                  }
                  @for (p of r.pills; track $index) {
                    <span [class]="p.cls" [attr.title]="p.title || null">{{ p.label }}</span>
                  }
                  @if (r.anomalies.length || r.blocked) {
                    <span class="pill anom" [class.blocking]="r.blocked" [attr.title]="r.anomalies.join('\n') || null" (click)="onAnomalies(r, $event)">⚠ {{ r.anomalies.length || '' }}</span>
                  }
                  <!-- En attendant le numéro de série des assets : l'id de la ligne de commande distingue deux matériels identiques d'un même client. -->
                  <small class="lid" title="Identifiant de la ligne de commande">id {{ r.id }}</small>
                </span>
                @if (r.product) { <span class="pn link" (click)="onArticle(r, $event)">{{ r.product }}</span> }
                <span class="mt">@for (p of r.meta; track $index) {<span [class.strong]="p.b">{{ p.text }}</span>}</span>
              </button>
              @if (r.contract) {
                <button type="button" class="key-only contract-key" (click)="onContract(r, $event)">{{ r.contract.title }}</button>
              }
              @if (r.article) {
                <button type="button" class="key-only contract-key article-key" (click)="onArticle(r, $event)">{{ r.article.title }}</button>
              }
              @if (r.anomalies.length || r.blocked) {
                <button type="button" class="key-only anom-key" [attr.aria-label]="'Anomalies de ' + r.name" (click)="onAnomalies(r, $event)">⚠ Anomalies</button>
              }
              <div class="fr-lines bg" [attr.data-line]="r.id">
                <div class="track pres">
                  @for (p of r.presence; track $index) {
                    <i class="bar" [class.fut]="p.fut" [style.left.%]="p.left" [style.width.%]="p.width"></i>
                  }
                  @for (m of r.markers; track $index) {
                    <i [class]="'mk mk-' + m.kind" [style.left.%]="m.left" [attr.title]="m.title"></i>
                  }
                  <!-- Flèche de BL (JP 30/10) : bouton vers sa planification sur la page du dossier ; l'infobulle vient du survol de la frise (data-*). -->
                  @for (a of r.arrows; track a.id + a.kind) {
                    @if (blLinks) {
                      <button type="button" [class]="a.cls" [style.left.%]="a.left" [attr.data-line]="r.id" [attr.data-bl]="a.id" [attr.data-kind]="a.kind" [attr.aria-label]="a.aria + ' : accéder à la planification'" (click)="onOpenBl(a.id)"><ng-container *ngTemplateOutlet="tri" /></button>
                    } @else {
                      <i [class]="a.cls" [style.left.%]="a.left" [attr.data-line]="r.id" [attr.data-bl]="a.id" [attr.data-kind]="a.kind"><ng-container *ngTemplateOutlet="tri" /></i>
                    }
                  }
                </div>
                <div class="track presc">
                  @for (p of r.prescriptions; track $index) {
                    <i class="rx" [style.left.%]="p.left" [style.width.%]="p.width"></i>
                  }
                </div>
                <div class="track bill">
                  @for (s of r.segs; track $index) {
                    <i [class]="'seg-day ' + s.cls" [style.left.%]="s.left" [style.width.%]="s.width"></i>
                  }
                  @for (o of r.outside; track $index) {
                    <i class="seg-day s-outside-present" [style.left.%]="o.left" [style.width.%]="o.width"></i>
                  }
                </div>
                <div class="track ledger">
                  @for (b of r.ledger; track $index) {
                    <i [class]="b.credit ? 'cred' : 'inv'" [style.left.%]="b.left" [style.width.%]="b.width"></i>
                  }
                  @for (t of r.ticks; track $index) {
                    <i class="tick" [style.left.%]="t"></i>
                  }
                </div>
              </div>
            </div>
          }
        } @empty {
          <div class="fr-empty">Aucun matériel ne correspond aux filtres.</div>
        }

        @if (vm.todayPct !== null) {
          <div class="today-line" [style.left]="'calc(var(--lab) + (100% - var(--lab)) * ' + vm.todayPct / 100 + ')'"></div>
        }
      </div>
    </div>

    @if (vm.legend.length) {
      <div class="legend">
        @for (it of vm.legend; track it.label) {
          @if (it.kind === 'arrow') {
            <span><i [class]="it.cls"><ng-container *ngTemplateOutlet="tri" /></i>{{ it.label }}</span>
          } @else {
            <span [attr.title]="it.title || null"><i [class]="it.kind === 'marker' ? 'lg-mk mk-' + it.marker : it.cls"></i>{{ it.label }}</span>
          }
        }
      </div>
    }
  }

  <div class="tip" #tip role="tooltip"></div>

  @if (pop; as p) {
    <div class="docs-pop" role="dialog" [attr.aria-label]="'Pièces jointes de ' + p.title" [style.left.px]="p.left" [style.top.px]="p.top" [style.bottom.px]="p.bottom" [style.max-height.px]="p.maxHeight"
      (mouseenter)="onPopEnter()" (mouseleave)="onPopLeave()">
      @for (it of p.items; track it.row.id) {
      <div class="pop-item">
      <div class="pop-head">
        <div class="pop-title"><span class="nm">{{ it.row.name }}</span>@if (it.memo) {<span class="mt"> · {{ it.memo }}</span>}</div>
        @if (it.row.product) { <div class="pop-article">{{ it.row.product }}</div> }
        @if (it.row.contract; as ct) {
          <button type="button" class="pop-link" (click)="onContract(it.row, $event)">{{ ct.title }}</button>
        }
      </div>
      <div class="pop-sec">
        <div class="sec-head">
          <span>Pièces du matériel</span>
          <span class="spacer"></span>
          <button mat-stroked-button type="button" class="pop-add" [disabled]="uploading" (click)="attachTo([it.row.id], $event)" title="Joindre un ou plusieurs fichiers à ce matériel">
            <mat-icon>attach_file</mat-icon>{{ uploading ? 'Dépôt…' : 'Importer' }}
          </button>
        </div>
        @if (!docsLoaded) {
          <div class="pop-none"><mat-spinner diameter="16"></mat-spinner>Chargement des pièces…</div>
        } @else {
          @if (!it.own.length) { <div class="pop-none">Aucune pièce jointe à ce matériel.</div> }
          <!-- Toujours rendu : la suppression vide le tableau avant la réponse du serveur, imagesChanged doit encore arriver. -->
          <app-image-carousel [attachs]="it.own" (imagesChanged)="loadDocs(true)"></app-image-carousel>
        }
      </div>
      @for (sec of it.others; track sec.key) {
        <div class="pop-sec">
          <div class="sec-head"><span>{{ sec.title }}</span></div>
          <app-image-carousel [attachs]="sec.docs" (imagesChanged)="loadDocs(true)"></app-image-carousel>
        </div>
      }
      </div>
      }
    </div>
  }
  @if (blPop; as p) {
    <!-- BL du patient (survol de son nom) : planification, BL signé, tournée ; un lien sans cible est grisé, jamais caché. -->
    <div class="docs-pop bl-pop" role="dialog" [attr.aria-label]="'BL de ' + p.title" [style.left.px]="p.left" [style.top.px]="p.top" [style.bottom.px]="p.bottom" [style.max-height.px]="p.maxHeight"
      (mouseenter)="onBlPopEnter()" (mouseleave)="onBlPopLeave()">
      <div class="pop-head"><div class="pop-title"><span class="nm">{{ p.title }}</span><span class="mt"> · BL du patient</span></div></div>
      @if (!docsLoaded) {
        <div class="pop-none"><mat-spinner diameter="16"></mat-spinner>Chargement des BL…</div>
      } @else {
        @for (it of p.items; track it.id) {
          <div class="pop-sec">
            <div class="bl-head"><span class="bl-title">{{ it.title }}</span><span class="bl-when">{{ it.when }}</span></div>
            <div class="bl-links">
              <button type="button" class="pop-link" (click)="onOpenBl(it.id)">Accéder à la planification</button>
              @if (it.signedUrl) {
                <a class="pop-link" [href]="it.signedUrl" target="_blank" title="PDF du BL signé (nouvel onglet)">Ouvrir le BL signé</a>
              } @else {
                <span class="pop-link off" aria-disabled="true" [title]="it.signedTip">Ouvrir le BL signé</span>
              }
              @if (it.boardUrl) {
                <a class="pop-link" [href]="it.boardUrl" target="_blank" title="Board des tournées de ce jour, BL encadré (nouvel onglet)">Voir dans la tournée</a>
              } @else {
                <span class="pop-link off" aria-disabled="true" [title]="it.boardTip">Voir dans la tournée</span>
              }
            </div>
          </div>
        } @empty {
          <div class="pop-none">Aucun BL pour les matériels affichés de ce patient.</div>
        }
      }
    </div>
  }
  <input #docInput type="file" hidden multiple (change)="onDocsPicked($event)" />
  <button type="button" class="menu-anchor" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="piecesMenu" [style.left.px]="menuAt.x" [style.top.px]="menuAt.y" tabindex="-1" aria-hidden="true"></button>
</div>

<!-- Triangle pointé à droite ; la reprise le retourne en CSS (.ret). -->
<ng-template #tri><svg viewBox="0 0 22 24" aria-hidden="true"><polygon points="1,1.5 20.5,12 1,22.5" /></svg></ng-template>

<mat-menu #piecesMenu="matMenu">
  @for (p of menuPieces; track p.invoice_line_id) {
    <button mat-menu-item type="button" (click)="openPiece(p, $event)">{{ pieceLabel(p) }}</button>
  }
</mat-menu>
